/**
 * Función utilitaria para copiar texto al portapapeles
 * Incluye fallback para navegadores que no soportan la Clipboard API
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // Verificar si el navegador soporta la Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback para navegadores que no soportan clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const success = document.execCommand('copy');
        document.body.removeChild(textArea);
        return success;
      } catch (err) {
        document.body.removeChild(textArea);
        console.error('Error al copiar con fallback:', err);
        return false;
      }
    }
  } catch (error) {
    console.error('Error al copiar al portapapeles:', error);
    return false;
  }
};

/**
 * Hook personalizado para copiar al portapapeles con notificaciones
 */
export const useClipboard = () => {
  const copyWithNotification = async (text: string, successMessage: string = 'Copiado al portapapeles', errorMessage: string = 'No se pudo copiar al portapapeles') => {
    const success = await copyToClipboard(text);
    
    if (success) {
      // Importar toast dinámicamente para evitar problemas de dependencias
      import('react-hot-toast').then(({ default: toast }) => {
        toast.success(successMessage, { icon: '📋', position: 'top-center' });
      });
    } else {
      import('react-hot-toast').then(({ default: toast }) => {
        toast.error(errorMessage, { icon: '⚠️', position: 'top-center' });
      });
    }
    
    return success;
  };

  return { copyWithNotification, copyToClipboard };
};
